import 'babel-polyfill'

// import 'ant-design-vue/dist/antd.less'
import '@/assets/less/style.less'

import Vue from 'vue'
import Antd from 'ant-design-vue'
import Vuelidate from 'vuelidate'

import App from '@/App.vue'
import router from '@/router'
import { store } from '@/store'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDRMn3giTWuqPqCQMP9Pgc-eU2ZOokl1qI'
  }
})

Vue.use(Antd)
Vue.use(Vuelidate)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
